import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import InlineText from '../../InlineEdit/InlineText';
import InlineTextArea from '../../InlineEdit/InlineTextArea';
import { imageScaleUrl } from '../../../helpers/imageScales';
import './FeaturedMenu.scss';

const DEFAULTS = {
  eyebrow: 'Menu dégustation',
  heading: 'Menu en quatre temps — entrée, plat, fromage ou dessert.',
  description:
    'Une suite composée par le chef autour des arrivages de la semaine. Servi tous les soirs sur réservation, ainsi que le samedi midi.',
  price_value: '55',
  price_unit: '€',
  price_label: 'par personne',
  cta_label: 'Voir le menu',
};

const View = (props: any) => {
  const { data, isEditMode, block, onChangeBlock, imageSlot } = props;

  const update = (field: string, value: string) =>
    onChangeBlock(block, { ...data, [field]: value });

  const get = (field: keyof typeof DEFAULTS) =>
    data[field] ?? (isEditMode ? '' : DEFAULTS[field]);

  const ctaLabel = get('cta_label');
  const ctaHref = data.cta_href || '/menu';

  const imageUrl =
    Array.isArray(data.image) && data.image.length > 0
      ? imageScaleUrl(data.image[0], 'great')
      : null;

  const defaultImageElement = imageUrl ? (
    <img src={imageUrl} alt={get('heading') || ''} loading="lazy" />
  ) : null;

  const slotted = imageSlot?.({
    fieldId: 'image',
    value: data.image,
    element: defaultImageElement,
  });

  const showImage = Boolean(imageUrl) || Boolean(slotted);

  return (
    <section className={`featured${showImage ? ' featured--with-image' : ''}`}>
      <div className="shell">
        <div className="featured-card">
          {showImage && (
            <div className="featured-img">{slotted ?? defaultImageElement}</div>
          )}
          <div className="featured-copy">
            <p className="eyebrow">
              {isEditMode ? (
                <InlineText
                  value={get('eyebrow')}
                  onChange={(v) => update('eyebrow', v)}
                  renderTag="span"
                  placeholder="Sur-titre (Menu dégustation…)"
                />
              ) : (
                get('eyebrow')
              )}
            </p>
            <h2>
              {isEditMode ? (
                <InlineText
                  value={get('heading')}
                  onChange={(v) => update('heading', v)}
                  renderTag="span"
                  placeholder="Titre du menu"
                />
              ) : (
                get('heading')
              )}
            </h2>
            {isEditMode ? (
              <InlineTextArea
                value={get('description')}
                onChange={(v) => update('description', v)}
                renderTag="p"
                placeholder="Description du menu, ingrédients, déroulé…"
              />
            ) : (
              get('description') && <p>{get('description')}</p>
            )}
            {isEditMode ? (
              <div className="featured-actions">
                <span className="btn btn-primary featured-action-preview">
                  <InlineText
                    value={ctaLabel}
                    onChange={(v) => update('cta_label', v)}
                    renderTag="span"
                    placeholder="Voir le menu"
                    ariaLabel="Texte du bouton"
                  />
                  <span className="arrow" aria-hidden="true">
                    →
                  </span>
                </span>
              </div>
            ) : (
              ctaLabel && (
                <div className="featured-actions">
                  <UniversalLink className="btn btn-primary" href={ctaHref}>
                    {ctaLabel}
                    <span className="arrow" aria-hidden="true">
                      →
                    </span>
                  </UniversalLink>
                </div>
              )
            )}
          </div>
          <div className="featured-price-wrap">
            <div className="featured-price">
              <span className="featured-price-amount">
                {isEditMode ? (
                  <InlineText
                    value={get('price_value')}
                    onChange={(v) => update('price_value', v)}
                    renderTag="span"
                    placeholder="55"
                    ariaLabel="Valeur du prix"
                  />
                ) : (
                  get('price_value')
                )}
                &nbsp;
                {isEditMode ? (
                  <InlineText
                    value={get('price_unit')}
                    onChange={(v) => update('price_unit', v)}
                    renderTag="span"
                    placeholder="€"
                    ariaLabel="Devise"
                  />
                ) : (
                  get('price_unit')
                )}
              </span>
              {(isEditMode || get('price_label')) && (
                <small>
                  {isEditMode ? (
                    <InlineText
                      value={get('price_label')}
                      onChange={(v) => update('price_label', v)}
                      renderTag="span"
                      placeholder="par personne"
                      ariaLabel="Libellé du prix"
                    />
                  ) : (
                    get('price_label')
                  )}
                </small>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default View;
